import { Link } from 'react-router-dom';
import { useLang } from '../i18n/context';
import { Container, Reveal } from '../components/Reveal';

export default function NotFound() {
    const { t, lang } = useLang();
    return (
        <section className="flex min-h-[70vh] items-center pt-24" data-testid="not-found">
            <Container>
                <Reveal className="mx-auto max-w-xl text-center">
                    <p className="font-serif text-7xl italic text-peri-300">404</p>
                    <h1 className="mt-4 font-serif text-3xl font-semibold text-ink md:text-4xl">{t.notFound.title}</h1>
                    <p className="mt-4 text-base leading-relaxed text-ink-muted">{t.notFound.text}</p>
                    <Link to={`/dental/${lang}`} className="mt-8 inline-flex rounded-full bg-gold-400 px-7 py-3 text-sm font-semibold text-ink hover:bg-gold-500" data-testid="not-found-home">
                        {t.notFound.cta}
                    </Link>
                </Reveal>
            </Container>
        </section>
    );
}
